import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { Store } from '@ngrx/store';
import { map } from 'rxjs/operators';

import { Go } from '@ui/legacy-lib';
import { getCompletedStep } from '../+state/landlords/landlords.selectors';

export const EditLandlordStepsGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const store = inject(Store);

  const requireCompleted = route.data.requireCompletion;
  return store.select(getCompletedStep).pipe(
    map(completedSteps => {
      if (completedSteps.includes(requireCompleted)) return true;
      const landlordId = (route.params.landlordId ||
        state.url.split('/')[2]) as string;
      if (landlordId && landlordId !== 'create') {
        store.dispatch(
          new Go({
            path: [`landlord/${landlordId}/edit/authentication`]
          })
        );
        return true;
      }
      store.dispatch(
        new Go({
          path: [`landlord/create/${String(requireCompleted)}`]
        })
      );
    })
  );
};
